$(document).ready(function () {
  $("body").append($(".modal"));
});
